export default __webpack_public_path__ + "static/logo-eec1a06ba9598767b1aa834f7be9c784.svg";